// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TPublicWebV1MapRequest, TPublicWebV1MapModel, IMappers, TPublicWebV1MapResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicWebV1MapResponse } from '../../../entities/response/PublicWebV1MapResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicWebV1MapModel(parameters: TPublicWebV1MapRequest): TPublicWebV1MapModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/web/v1/map/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicWebV1MapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicWebV1MapRequest;
}

export async function fetchPublicWebV1Map<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicWebV1MapOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicWebV1MapResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicWebV1MapModel(parameters),
    config,
  )) as FetchResponse<TPublicWebV1MapResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicWebV1MapResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicWebV1MapResponse>;
}
